import * as ko from "knockout";
import {ObjectTypeId} from "../../constants";
import {getObjectDefinition, IObjectDefinition} from "../../util/misc";
import {IObjectType, TBaseOrObservableType} from "../../index";
import object_type_nameHtml from './object-type-name.html?raw';

export let template = object_type_nameHtml;

interface IParams {
    id?: TBaseOrObservableType<ObjectTypeId>
    type?: TBaseOrObservableType<IObjectType>
    showIcon?: boolean
}

export class viewModel {
    private readonly showIcon: boolean;
    constructor(private params: IParams) {
        this.showIcon = params.showIcon ?? true
    }

    private objDef = ko.pureComputed((): IObjectDefinition | null => {
        return getObjectDefinition(this.getObjectTypeId());
    })

    private getObjectTypeId(): ObjectTypeId | undefined {
        if ('id' in this.params && this.params.id !== undefined) {
            return ko.unwrap(this.params.id);
        }
        if ('type' in this.params && this.params.type !== undefined) {
            return ko.unwrap(this.params.type)?.id;
        }
        return undefined;
    }
}
